import Select from 'react-select-plus'
import { BUFFER_LENGTH_OPTIONS, NOTICE_TIME_OPTIONS } from '../constants'

const Section = props => <div {...props} className={props.className} />

const BufferSettings = ({ meetingSettings, handleSelectBufferTime, handleSelectMinimumNoticeTime }) => {
  return (
    <div className="meeting-settings">
      <Section>
        <form className="drift-form advanced-meeting-settings">

          <fieldset>
            <label className="settings-label">
              Minimum Notice Time
              <Select
                value={meetingSettings.minimumNoticeTime}
                searchable={false}
                clearable={false}
                options={NOTICE_TIME_OPTIONS}
                onChange={handleSelectMinimumNoticeTime}
              />
              <div className="description">
                This is the minimum amount of time before a meeting can be scheduled.
              </div>
            </label>
          </fieldset>
          <fieldset>
            <label className="settings-label">
              Buffer Time
              <Select
                value={meetingSettings.bufferTime}
                searchable={false}
                clearable={false}
                options={BUFFER_LENGTH_OPTIONS}
                onChange={handleSelectBufferTime}
              />
              <div className="description">
                Drift will make sure you have enough time between your meetings.
              </div>
            </label>
          </fieldset>
        </form>
      </Section>
    </div>
  )
}

export default BufferSettings



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/BufferSettings/component.js